/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ProjectRoleActorDetail from '@jira/spa-apps__admin-pages-performance-metric-detail-project-role-actor/src/ProjectRoleActorDetail.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectRoleActorDetail: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProjectRoleActorDetail
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-project-role-actor" */ '@jira/spa-apps__admin-pages-performance-metric-detail-project-role-actor/src/ProjectRoleActorDetail.tsx'
		),
	),
);

export const ProjectRoleActorMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectRoleActorDetail}
		pageId="system-performance-metric-detail-project-role-actor"
		shouldShowSpinner
	/>
);
